import { Component, HostListener, OnInit, OnChanges, SimpleChanges, AfterViewInit, ElementRef, ViewChild, ChangeDetectorRef } from '@angular/core';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit, OnChanges, AfterViewInit {  
  @ViewChild('footer', { static: false }) footerElement: ElementRef | undefined;

  showFooter = false;
  footerPosition: number = 0;
  
  ngOnChanges(changes: SimpleChanges): void {
    //console.log("showFooter.ngOnChanges:"+this.showFooter);
  }

  ngAfterViewInit(): void {
    //console.log("showFooter.AfterViewInit:"+this.showFooter);
    // Verificar nuevamente después de que la vista esté inicializada
    setTimeout(() => {
      this.updateFooterVisibilityNew();
    }, 100);
  }

  constructor(private cdr: ChangeDetectorRef) { }

  ngOnInit(): void {
    //console.log("showFooter.ngOnInit:"+this.showFooter);
    // Verificar la posición inicial del scroll al cargar la página
    this.updateFooterVisibilityNew();
  }

  @HostListener('window:scroll', ['$event'])
  onScroll(event: any): void {
    this.updateFooterVisibilityNew();
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: any): void {
    // Recalcular cuando cambie el tamaño de la ventana (ej: rotación de pantalla en móvil)
    this.updateFooterVisibilityNew();
  }

  updateFooterVisibilityNew() {
    setTimeout(() => {
      const documentHeight = document.documentElement.scrollHeight; // Altura total del documento
      const scrollPosition = window.scrollY; // Posición actual del scroll
      const windowHeight = window.innerHeight; // Altura de la ventana
      const currentScroll = scrollPosition + windowHeight; // Scroll + ventana

      // Margen de tolerancia para dispositivos móviles (algunos navegadores móviles tienen scroll "elástico")
      const tolerance = 5;

      // El usuario ha llegado al final o está muy cerca del final
      const isAtBottom = currentScroll >= (documentHeight - tolerance);

      // Calcular si hay muy poco espacio restante (menos de 50px)
      const remainingSpace = documentHeight - currentScroll;
      const isNearBottom = remainingSpace <= 50;

      // Mostrar el footer si está en el fondo o muy cerca
      if (isAtBottom || isNearBottom) {
        this.showFooter = true;
      } else {
        this.showFooter = false;
      }

      // Forzar detección de cambios para asegurar que Angular actualice la vista
      this.cdr.detectChanges();

      //console.log("showFooter:", this.showFooter, "| isAtBottom:", isAtBottom, "| remainingSpace:", remainingSpace);
    }, 0);  // Usamos setTimeout con un tiempo de 0 para retrasar la ejecución
  }

  updateFooterVisibility() {
    setTimeout(() => {
      const documentHeight = document.documentElement.scrollHeight; // Altura total del documento
      const currentScroll = window.scrollY + window.innerHeight; // Altura del scroll actual
      var footerHeight = 280;//this.footerElement?.nativeElement.offsetHeight || 0; // Altura del footer
      const screenWidth = window.innerWidth;
      // Si estamos en una pantalla pequeña (móvil), cambiamos la altura del footer
      if (screenWidth <= 768) {
        footerHeight = 400; // Ajusta esta altura según lo que necesites para móviles
      } else {
        footerHeight = 280; // Valor para pantallas más grandes
      }
      const windowHeight = window.innerHeight; // Altura de la ventana del navegador
      // Verificamos si hay suficiente espacio sobrante en la página
      //const remainingSpace = documentHeight - currentScroll - windowHeight;
      const remainingSpace = documentHeight - window.scrollY - window.innerHeight;
      const remainingSpace1 = currentScroll - (documentHeight - footerHeight);
      //console.log("showFooter:documentHeight:"+documentHeight+">>currentScroll:"+currentScroll+">>footerHeight:"+footerHeight+">>windowHeight:"+windowHeight+">>remainingSpace:"+remainingSpace+">>dif1:"+(documentHeight - footerHeight)+">>remainingSpace1:"+remainingSpace1);
      // Si el espacio sobrante es mayor o igual a la altura del footer, mostramos el footer
      if (remainingSpace >= footerHeight && remainingSpace<=0) {
        this.showFooter = true;
        //console.log("showFooter:here1:" + this.showFooter);
      }
      // Si el usuario ha llegado al final de la página, también mostramos el footer
      //else if (currentScroll >= documentHeight - footerHeight && remainingSpace1===footerHeight) {
      else if (currentScroll >= documentHeight - footerHeight && remainingSpace1-footerHeight>=-1.0 && remainingSpace1-footerHeight<=1.0) {
        this.showFooter = true;
        //console.log("showFooter:here2:" + this.showFooter);
      } else {
        this.showFooter = false;
        //console.log("showFooter:here3:" + this.showFooter);
      }
      if (documentHeight-currentScroll<=400){
        //console.log("showFooter1:" + this.showFooter+">>documentHeight:"+documentHeight+">>currentScroll:"+currentScroll+">>windowHeight:"+windowHeight+">>remainingSpace:"+remainingSpace+">>remainingSpace1:"+remainingSpace1+">>footerHeight:"+footerHeight);
      }  
    }, 0);  // Usamos setTimeout con un tiempo de 0 para retrasar la ejecución
  }

}  
